import { useEffect, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { Helmet } from 'react-helmet-async';
import qs from 'qs';
import { localSiteHost } from '../utils/sharedUtilities';
import { post } from '../utils/apiUtilities';

function LogOut({ location, setIsAuthenticated }) {
    const logoutId = qs.parse(location.search, { ignoreQueryPrefix: true }).logoutId;

    const [errorMessage, setErrorMessage] = useState('');
    const [referrerName, setReferrerName] = useState('CBRNResponder');
    const [showSignoutPrompt, setShowSignoutPrompt] = useState(false);
    const [isSigningOut, setIsSigningOut] = useState(false);

    const logout = async (e) => {
        e.preventDefault();
        setIsSigningOut(true);

        try {
            const d = await post(`account/logout`, {
                LogoutId: logoutId
            });

            setIsAuthenticated(false);

            if (d.redirect) {
                window.location.href = d.redirect;
            }
        }
        catch (err) {
            setIsSigningOut(false);
            if (err && err.responseText) {
                setErrorMessage((err.status === 400 || err.status === 401) ? err.responseText : 'An error occurred while signing out.');
            }

            throw (err);
        }
    }

    const init = useCallback(async () => {
        setShowSignoutPrompt(false);

        const d = await $.ajax({
            url: `${localSiteHost}/api/account/logout?logoutId=${(logoutId || '')}`,
            type: "GET",
            contentType: "application/json"
        });

        setReferrerName(d.referrerName);

        if (!d.ShowLogoutPrompt && d.redirect) {
            window.location.href = d.redirect;
        }
        else {
            setShowSignoutPrompt(true);
        }

    }, [logoutId]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <>
            <Helmet>
                <title>Sign Out | CBRN Network</title>
            </Helmet>
            <div id="layout-shell" className="shell top100">
                <div className="main-content container" id="mainContent" tabIndex="-1">                    
                        {(() => {
                            if (showSignoutPrompt) {
                                return <div className="row">
                                    <main>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                            {(!(errorMessage && errorMessage.length) ? '' : (
                                                <div className="alert alert-danger">
                                                    <span dangerouslySetInnerHTML={{ __html: errorMessage }}></span>
                                                </div>
                                            ))}
                                            <div className="panel panel-default">
                                                <div className="panel-body">
                                                    <div className="lead">
                                                        <h1>Sign Out</h1>
                                                        <p>Would you like to sign out of {referrerName}?</p>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="col-sm-12">
                                                            <button id="confirmLogoutButton"
                                                                className="btn btn-success btn-lg btn-block"
                                                                name="button"
                                                                disabled={isSigningOut}
                                                                onClick={logout}>
                                                                {isSigningOut ? 'Signing out...' : 'Sign Out'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </div>
                                    </main>
                                </div>;
                            }
                            else {
                                return <div>
                                        <h1 class="text-center">
                                                <p>Signing out</p>
                                                <i class="fa fa-solid fa-lg fa-spinner fa-spin"></i>
                                        </h1>
                                        <div class="text-center">
                                            Please wait while the system signs you out.
                                        </div>
                                    </div>;
                            }
                        })()}
                </div>
            </div>
        </>
    );
}

export default withRouter(LogOut);
